import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import NativeSelect from '@material-ui/core/NativeSelect';

import MbRadioGroup from 'components/molecules/MbRadioGroup';
import Popover from 'components/molecules/Popover';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    padding: '0 25px',
    display: 'flex',
    alignItems: 'center',
  },
  selectbox: {
    height: '100%',
    marginLeft: 17,
  },
}));

let closePopover = () => {};

/**
 * 외부연동 관련 필터 모음
 * @param id
 * @param itlTpCode
 * @param handleOnExternalChange
 * @param useRtb
 * @returns {*}
 * @constructor
 */
const ExternalFilter = ({ id, itlTpCode, handleOnExternalChange, useRtb }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { externalCodeList } = useSelector(({ common }) => ({
    externalCodeList: (() => {
      const externalCodeList = [].concat(common.externalCodeList);
      externalCodeList.unshift({
        label: t('전체'),
        value: '00',
      });
      return externalCodeList;
    })(),
  }));
  if (useRtb) {
    externalCodeList.splice(0, 2);
  }
  const [externalOnOff, setExternalOnOff] = useState('on');
  const [externalCode, setExternalCode] = useState(useRtb ? '03' : '00');
  const [selectedIndex, setSelectedIndex] = useState(useRtb ? 1 : 0);

  useEffect(() => {
    if (typeof itlTpCode === 'undefined') {
      // 필터 초기화
      setExternalOnOff('on');
    }
  }, [itlTpCode]);

  const handleOnOff = (e) => {
    const { value } = e.target;
    setExternalOnOff(value);
    if (value === 'off') {
      handleOnExternalChange(null);
    } else {
      handleOnExternalChange(externalCode);
    }
    closePopover();
  };

  const handleOnChange = (e) => {
    const { value, selectedIndex } = e.target;

    setSelectedIndex(selectedIndex);
    setExternalCode(value);
    handleOnExternalChange(value);
    closePopover();
  };

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  const getOnClose = (handleClose) => {
    closePopover = handleClose;
  };

  return (
    <>
      <Popover
        label={t('외부연동')}
        getOnClose={getOnClose}
        selectedLabel={externalCodeList[selectedIndex].label}
        filtered={externalOnOff !== 'off'}
        filterList={
          <div className={classes.root}>
            <MbRadioGroup
              selectedValue={externalOnOff}
              radioList={[
                {
                  label: t('ON'),
                  value: 'on',
                },
                {
                  label: t('OFF'),
                  value: 'off',
                  disabled: useRtb ? true : false,
                },
              ]}
              onChange={handleOnOff}
              name="external"
            />
            <NativeSelect
              className={classes.selectbox}
              value={externalCode}
              disabled={externalOnOff === 'off'}
              name="external"
              onChange={handleOnChange}
            >
              {externalCodeList.map((data) => {
                const { value, label } = data;
                return (
                  <option key={value} value={value}>
                    {label}
                  </option>
                );
              })}
            </NativeSelect>
          </div>
        }
      />
    </>
  );
};

export default ExternalFilter;
